<template>
  <div class="flex">
    <span class="flex flex_between">
      <md-field v-if="showFrom" class="input_box">
        <template>
          <label> from </label>
          <md-input
            class="input_box"
            v-model="fromValue"
            @change="changeFrom"
            :disabled="disabled"
            type="number"
            required
          ></md-input>
        </template>
      </md-field>
      <span v-else class="input_box"></span>
      <span>
        {{ unit }}
      </span>
    </span>
    <span class="slider_box flex_1">
      <el-slider
        v-model="value"
        range
        :marks="marks"
        :max="sliderData.max"
        :disabled="disabled"
        :min="sliderData.min"
        @input="changeValue"
      >
      </el-slider>
    </span>
    <span class="flex flex_between">
      <md-field class="input_box">
        <label> to </label>
        <md-input
          v-model="toValue"
          @change="changeTo"
          class="input_box"
          :disabled="disabled"
          type="number"
          required
        ></md-input>
      </md-field>
      <span>
        {{ unit }}
      </span>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    unit: {
      type: String,
      default: "°C",
    },
    disabled: Boolean,
    sliderType: {
      type: String,
      default: "temperature", //
    },
    showFrom: {
      type: Boolean,
      default: true,
    },
    initValue: {
      type: [String, Number, Array],
      default: () => {
        return [0, 20];
      },
    },
  },
  data() {
    return {
      value: [0, 20],
      toValue: "",
      fromValue: "",
      markData: {
        temperature: {
          marks: {
            "-30": "-30",
            "-20": "-20",
            0: "0",
            20: "20",
            40: "40",
            60: "60",
            80: "80",
          },
          min: -30,
          max: 80,
        },
        intensity: {
          marks: {
            0: "0",
            4000: "4,000",
            8000: "8,000",
            12000: "12,000",
            16000: "16,000",
          },
          min: 0,
          max: 16000,
        },
        duration: {
          marks: {
            0: "0",
            40: "40",
            80: "80",
            120: "120",
            160: "160",
          },
          min: 0,
          max: 160,
        },
      },
    };
  },
  computed: {
    marks() {
      return this.markData[this.sliderType].marks;
    },
    sliderData() {
      return this.markData[this.sliderType];
    },
  },
  watch: {
    initValue() {
      this.value = this.initValue;
    },
  },
  mounted() {
    this.value = this.initValue;
  },
  methods: {
    changeValue() {
      this.fromValue = this.value[0];
      this.toValue = this.value[1];
      this.emitValue();
    },
    changeFrom() {
      this.value = [Number(this.fromValue), this.value[1]];
      console.log(this.value);
      this.emitValue();
    },
    changeTo() {
      this.value = [this.value[0], Number(this.toValue)];
      this.emitValue();
    },
    emitValue() {
      this.$emit("changeSlider", {
        value: this.value,
        sliderType: this.sliderType,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.slider_box {
  padding: 0 30px;
}
.input_box {
  display: inline-block;
  width: 90px;
}
</style>
